<template>
  <section class="d-grid gap-1 sponser px-0">
    <h3
      v-if="showDifferentTitle.length"
      class="service has-text-centered is-size-3"
    >
      {{ $t(showDifferentTitle) }}
    </h3>
    <h3
      v-else
      class="is-narrow is-size-4 has-text-black has-text-weight-bold pl-0"
    >
      {{ $t('topEmployers') }}
    </h3>
    <div class="slider">
      <div class="slide-track">
        <div v-for="img in employers" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
    <div class="slider">
      <div class="slide-track2">
        <div v-for="img in employers2" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
    <div class="slider">
      <div class="slide-track3">
        <div v-for="img in employers3" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
    <div class="slider">
      <div class="slide-track4">
        <div v-for="img in employers4" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
    <div class="slider">
      <div class="slide-track5">
        <div v-for="img in employers5" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    showDifferentTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      employers: [
        {
          id: 1,
          src: '/images/account/ambasdor_logo.jpg',
          alt: 'kitchen'
        },

        {
          id: 2,
          src: '/images/account/hydrebadi_dum.jpg',
          alt: 'hulas'
        },

        {
          id: 3,
          src: '/images/account/bajeko_sekuwa.jpg',
          alt: 'bajeko'
        },

        {
          id: 4,
          src: '/images/account/golden_gate.jpg',
          alt: 'websurfer'
        },

        { id: 5, src: '/images/account/goyal_logo.jpg', alt: 'lotus' },

        {
          id: 6,
          src: '/images/account/filli_cafe.jpg',
          alt: 'healthcare'
        },

        {
          id: 7,
          src: '/images/account/grand_norling.jpg',
          alt: 'zuleika'
        },

        { id: 8, src: '/images/account/haadi_logo.jpg', alt: 'hotel' },
        { id: 9, src: '/images/account/java_logo.jpg', alt: 'hotel' },

        { id: 10, src: '/images/account/mt_everest.jpg', alt: 'hotel' },
        {
          id: 11,
          src: '/images/account/level_three.jpg',
          alt: 'hotel'
        },

        { id: 12, src: '/images/account/jump_ktm.jpg', alt: 'hotel' },
        { id: 13, src: '/images/account/mugal_logo.jpg', alt: 'hotel' },
        {
          id: 14,
          src: '/images/account/paradise_hill.jpg',
          alt: 'hotel'
        },
        {
          id: 15,
          src: '/images/account/hotel_himalaya.jpg',
          alt: 'hotel'
        },
        {
          id: 16,
          src: '/images/account/jampa.jpg',
          alt: 'hotel'
        },
        {
          id: 17,
          src: '/images/account/jandt_associates.jpg',
          alt: 'hotel'
        },
        {
          id: 18,
          src: '/images/account/kh.jpg',
          alt: 'hotel'
        },
        {
          id: 19,
          src: '/images/account/kucho.jpg',
          alt: 'hotel'
        },
        {
          id: 20,
          src: '/images/account/kyampa.jpg',
          alt: 'hotel'
        },
        {
          id: 21,
          src: '/images/account/nd.jpg',
          alt: 'hotel'
        },
        {
          id: 22,
          src: '/images/account/newa_rockyard.jpg',
          alt: 'hotel'
        },
        {
          id: 23,
          src: '/images/account/nova.jpg',
          alt: 'hotel'
        },
        {
          id: 24,
          src: '/images/account/oriental_kitchen.jpg',
          alt: 'hotel'
        },
        {
          id: 25,
          src: '/images/account/parzada.jpg',
          alt: 'hotel'
        },
        {
          id: 26,
          src: '/images/account/world_link.jpg',
          alt: 'hotel'
        },
        {
          id: 27,
          src: '/images/account/tranquility_spa.png',
          alt: 'spa'
        }
      ],
      employers2: [
        {
          id: 1,
          src: '/images/account/rato_bangla.jpg',
          alt: 'hotel'
        },
        {
          id: 2,
          src: '/images/account/sarawagi_group.jpg',
          alt: 'hotel'
        },
        {
          id: 3,
          src: '/images/account/shangrilla_hotel.jpg',
          alt: 'hotel'
        },
        {
          id: 4,
          src: '/images/account/tukuche_thakali.jpg',
          alt: 'hotel'
        },
        { id: 5, src: '/images/account/tag_logo.jpg', alt: 'hotel' },
        {
          id: 6,
          src: '/images/account/united_school.jpg',
          alt: 'hotel'
        },
        { id: 7, src: '/images/account/dekhaido.jpg', alt: 'hotel' },
        { id: 8, src: '/images/account/alpha_beta.jpg', alt: 'hotel' },
        { id: 9, src: '/images/account/bhola_foods.jpg', alt: 'hotel' },
        { id: 10, src: '/images/account/biryani_adda.jpg', alt: 'hotel' },
        { id: 11, src: '/images/account/classy_printing.jpg', alt: 'hotel' },
        { id: 12, src: '/images/account/cotton_mill.jpg', alt: 'hotel' },
        { id: 13, src: '/images/account/dal_bhat.jpg', alt: 'hotel' },
        { id: 14, src: '/images/account/east_west_college.jpg', alt: 'hotel' },
        { id: 15, src: '/images/account/EE.jpg', alt: 'hotel' },
        { id: 16, src: '/images/account/el_maven.jpg', alt: 'hotel' },
        { id: 17, src: '/images/account/garuda.jpg', alt: 'hotel' },
        { id: 18, src: '/images/account/gem_plasticware.jpg', alt: 'hotel' },
        { id: 19, src: '/images/account/hafner.jpg', alt: 'hotel' },
        { id: 20, src: '/images/account/himalaya_institute.jpg', alt: 'hotel' },
        {
          id: 21,
          src: '/images/account/pretty_click.jpg',
          alt: 'hotel'
        },
        {
          id: 22,
          src: '/images/account/sabkura.jpg',
          alt: 'hotel'
        },
        {
          id: 23,
          src: '/images/account/samsara.jpg',
          alt: 'hotel'
        },
        {
          id: 24,
          src: '/images/account/the_soaltee.jpg',
          alt: 'hotel'
        },
        {
          id: 26,
          src: '/images/account/tukutuku_logo.jpg',
          alt: 'hotel'
        },
        {
          id: 27,
          src: '/images/account/tibsa.png',
          alt: 'spa'
        }
      ],
      employers3: [
        {
          id: 1,
          src: '/images/account/A Square-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 2,
          src: '/images/account/A-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 3,
          src: '/images/account/Anamnagar Union house-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 4,
          src: '/images/account/Annapurna Sweets-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 5,
          src: '/images/account/Atul-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 6,
          src: '/images/account/BA-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 7,
          src: '/images/account/Bhandari Sekuwa-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 8,
          src: '/images/account/Caffeophilia-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 9,
          src: '/images/account/Filli-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 10,
          src: '/images/account/G4-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 11,
          src: '/images/account/HP-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 12,
          src: '/images/account/Helmets Nepal-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 13,
          src: '/images/account/Himalayan-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 14,
          src: '/images/account/Hotel Bhadgaon-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 15,
          src: '/images/account/Indreni-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 16,
          src: '/images/account/Kathmandu Coffee-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 17,
          src: '/images/account/Khaanpin-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 18,
          src: '/images/account/Layer 1.jpg',
          alt: 'employer'
        },
        {
          id: 19,
          src: '/images/account/Musk Restaurant-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 20,
          src: '/images/account/Nepal house-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 21,
          src: '/images/account/Orange Ball-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 22,
          src: '/images/account/Pathao-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 23,
          src: '/images/account/Rato Bangala-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 24,
          src: '/images/account/RoadHouse-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 25,
          src: '/images/account/Royal Thaai Hospitality-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 26,
          src: '/images/account/Screenshot 2026-05-13 132113-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 27,
          src: '/images/account/Spark In-compressed.jpg',
          alt: 'employer'
        }
      ],
      employers4: [
        {
          id: 1,
          src: '/images/account/Star Boss-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 2,
          src: '/images/account/The Suit Atelier-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 3,
          src: '/images/account/The Suit Studio-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 4,
          src: '/images/account/Trisara-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 5,
          src:
            '/images/account/WhatsApp Image 2026-05-24 at 11.12.33 AM-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 6,
          src:
            '/images/account/WhatsApp Image 2026-05-27 at 7.24.44 PM (2)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 7,
          src:
            '/images/account/WhatsApp Image 2026-05-29 at 2.14.27 PM-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 8,
          src:
            '/images/account/WhatsApp Image 2026-05-31 at 11.36.01 AM-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 9,
          src:
            '/images/account/WhatsApp Image 2026-06-02 at 4.16.10 PM-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 10,
          src: '/images/account/Zhonghia-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 11,
          src: '/images/account/Zulika by Gahana Griha-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 12,
          src: '/images/account/gdasjhs-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 13,
          src: '/images/account/hotel natural spring-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 14,
          src: '/images/account/image (10)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 15,
          src: '/images/account/image (11)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 16,
          src: '/images/account/image (12)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 17,
          src: '/images/account/image (13)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 18,
          src: '/images/account/image (14)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 19,
          src: '/images/account/image (15)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 20,
          src: '/images/account/image (16)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 21,
          src: '/images/account/image (17)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 22,
          src: '/images/account/image (18)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 23,
          src: '/images/account/image (19)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 24,
          src: '/images/account/image (2)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 25,
          src: '/images/account/image (20)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 26,
          src: '/images/account/image (21)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 27,
          src: '/images/account/image (22)-compressed.jpg',
          alt: 'employer'
        }
      ],
      employers5: [
        {
          id: 1,
          src: '/images/account/image (23)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 2,
          src: '/images/account/image (24)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 3,
          src: '/images/account/image (25)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 4,
          src: '/images/account/image (26)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 5,
          src: '/images/account/image (27)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 6,
          src: '/images/account/image (28)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 7,
          src: '/images/account/image (29)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 8,
          src: '/images/account/image (3)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 9,
          src: '/images/account/image (30)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 10,
          src: '/images/account/image (31)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 11,
          src: '/images/account/image (32)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 12,
          src: '/images/account/image (33)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 13,
          src: '/images/account/image (34)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 14,
          src: '/images/account/image (4)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 15,
          src: '/images/account/image (5)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 16,
          src: '/images/account/image (6)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 17,
          src: '/images/account/image (7)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 18,
          src: '/images/account/image (8)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 19,
          src: '/images/account/image (9)-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 20,
          src: '/images/account/kinderpillar-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 21,
          src: '/images/account/kwality-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 22,
          src: '/images/account/logo of melung-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 23,
          src: '/images/account/logo-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 24,
          src: '/images/account/lp-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 25,
          src: '/images/account/smart-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 26,
          src: '/images/account/the chiya spot-compressed.jpg',
          alt: 'employer'
        },
        {
          id: 27,
          src: '/images/account/tropical-compressed.jpg',
          alt: 'employer'
        }
      ]
    }
  },
  mounted() {
    this.duplicateImages()
  },
  methods: {
    duplicateImages() {
      ;[
        '.slide-track',
        '.slide-track2',
        '.slide-track3',
        '.slide-track4',
        '.slide-track5'
      ].forEach(selector => {
        const slideTrack = document.querySelector(selector)
        const imagesCount = slideTrack.children.length

        for (let i = 0; i < imagesCount * 2; i++) {
          const imageIndex = i % imagesCount
          const clonedImage = slideTrack.children[imageIndex].cloneNode(true)
          slideTrack.appendChild(clonedImage)
        }
      })
    }
  }
}
</script>

<style>
.d-grid {
  display: grid;
}
.sponser {
  max-width: 84.375rem;
  width: 100%;
  margin: auto;
}
.service-image {
  grid-template-columns: repeat(9, 1fr);
  grid-auto-rows: 6rem;
}
.service-image img {
  background: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  object-fit: contain;
}
@media screen and (max-width: 760px) {
  .service-image {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 0;
  }
  .service-image img {
    width: 100%;
  }
}
.service h3 {
  line-height: 37px;
}
.lift-shadow {
  transition: 0.5s;
}
.lift-shadow:hover {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  transform: scale(1.02);
}
.slider {
  height: 6rem;
  margin: auto;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.slide-track {
  animation: scroll 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide-track2 {
  animation: right 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide-track3 {
  animation: scroll 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide-track4 {
  animation: right 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide-track5 {
  animation: scroll 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide {
  height: 2rem;
  width: 7rem;
}

@keyframes right {
  100% {
    transform: translateX(0);
  }
  0% {
    transform: translateX(calc(-250px * 7));
  }
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-250px * 7));
  }
}
</style>
